<template>
  <b-card
    header="Carte Temporaire"
    header-bg-variant="danger"
    header-text-variant="white"
    border-variant="danger"
    align="center">
    <b-card-text @click="goTo('/andon/'+item.kanban_reference.reference.code)">
      <b>{{displayRef(item.kanban_reference.reference.code)}}</b>
      <br />
      {{item.kanban_reference.reference.supermarket_emplacement}}
    </b-card-text>
    <!-- <b-button v-if="getIsAdmin()" size="sm" variant="danger" @click="stopCardAndon()"><i class="fa fa-trash" aria-hidden="true"></i></b-button> -->
    <b-button v-if="isUserAdmin()" size="sm" variant="danger" @click="deleteRef()">SUPER DELETE <i class="fa fa-trash" aria-hidden="true"></i></b-button>
  </b-card>
</template>
<script>

import server from '../../api/server.vue'
import {Steps} from '../../core/services/steps.js'

export default {
  name: 'TempCard',
  props: ['item'],
  data() {
    return {
      stepList: Steps
    };
  },
  methods: {
    stopCardAndon () {
      server.stopSpecificAndon(this.item.andon.base_id).then(() => {
        this.$emit('andon-stopped')
      })
    },
    displayRef(reference) {
      return this.chunk(reference, 3).join(' ')
    },
    chunk(str, n) {
      var ret = [];
      var i;
      var len;
      for(i = 0, len = str.length; i < len; i += n) {
        ret.push(str.substr(i, n))
      }
      return ret
    },
    deleteRef () {
      server.deleteReferenceFromAndonKanban(this.item.andon.kanban_reference.reference.code).then(() => {
        server.stopSpecificAndon(this.item.andon.base_id).then(() => {
            this.$emit('andon-stopped')
        })
      })
    },
    getIsAdmin() {
      return window.localStorage.getItem('isAdmin') === 'ADMIN'
    },
  }
};
</script>

<style scoped>
  .card {
    cursor: pointer;
  }
</style>


// WEBPACK FOOTER //
// src/components/andon/TempCard.vue